import { Box, Button, CircularProgress, useMediaQuery } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import useStyles from './style';
import Typography from '../../../../../../components/atoms/Typography';
import Link from '../../../../../../components/atoms/Link'
import ButtonMUI from '../../../../../../components/atoms/Button';

const createSVG = (type = '', customClass = '') => {
  switch (type) {
    case 'arrowForwardIcon':
      return (
        <svg className={`${customClass} customSVG`} width="4" height="8" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 9L5 5L1 1" stroke="#009086" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      )
    case 'cross':
      return (
        <svg className={`${customClass} customSVG`} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 2L10 10M2 10L10 2" stroke="#565A5C" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      )
    default:
      return <></>
  }
}

/**
 * CustomMapToast Component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.linkLabel=''] 
 * @param {string} [props.textTitle=''] 
 * @param {boolean} [props.showLinkLabel=true] 
 * @param {Function} props.handleClose
 * @param {Function} props.onClick
 * @returns {JSX.Element}
 */

const CustomMapToast = (props) => {
  const { linkLabel = '', textTitle = '', showLinkLabel = true, handleClose } = props
  const classes = useStyles();
  const isMobile = useMediaQuery(`(max-width:${1023}px)`);
  const renderLinkLabel = () => {
    return linkLabel
  }

  const onClickHandler = (e) => {
    e.preventDefault()
    props.onClick(e)
  }

  let duration = 3000
  const [count, setCount] = useState(100);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const intervalTime = isMobile ? duration / 100 : duration / 80; // Calculate the interval time based on duration
    let interval;

    if (!isPaused) {
      interval = setInterval(() => {
        setCount(prevCount => {
          if (prevCount > 0) {
            return prevCount - 1;
          } else {
            clearInterval(interval);
            return prevCount;
          }
        });
      }, intervalTime);
    }

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [duration, isPaused]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <Box
      className={classes.root}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Box className='passportToastWrapper'>
        <Box className='passportToastContentWrapper'>
          <Box className='passportToastInnerWrapper'>
            <Typography component={'h3'} className={'textTitle'}>{textTitle}</Typography>
            {showLinkLabel && linkLabel &&
              <Link
                onClick={(e) => onClickHandler(e)}
                isCustom={true}
                className="abuDhabiPassportLink"
              >
                <Typography className={'linkLabelText'} component={'span'}>{renderLinkLabel()}</Typography>
                {createSVG('arrowForwardIcon', 'arrowForwardIcon')}
              </Link>
            }
            {showLinkLabel && !linkLabel &&
              <ButtonMUI
                type="button"
                buttonType="form"
                size="small"
                tabIndex={0}
                hasBorder={false}
                className="passportToastBtn"
                onClick={(e) => onClickHandler(e)}
              >
                {renderLinkLabel()}
              </ButtonMUI>
            }
          </Box>
          <Button
            onClick={() => { handleClose() }}
            className='crossButton'
          >
            {createSVG('cross')} <CircularProgress variant="determinate" value={count} />
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default CustomMapToast